import axios from "axios";
import React, {
  useEffect,
  useState,
  useContext,
  Fragment,
  useMemo,
} from "react";
import { Link, useHistory } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";
import { MRT_Localization_DE } from "material-react-table/locales/de";
import { Box, Stack } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { translate } from "../../translations";

export default function Abrechnung() {
  const [orders, setOrders] = useState([]);
  const { userData } = useContext(UserDataContext);
  const history = useHistory();
  const token = localStorage.getItem("token");
  const project = localStorage.getItem("currentProjectID");
  const [kostenstellen, setKostenstellen] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [orderDataTotal, setOrderDataTotal] = useState(0);
  var date = new Date();
  const [timePeriod, setTimePeriod] = useState({
    startDate: new Date(date.getFullYear(), date.getMonth(), 1, 3)
      .toISOString()
      .substr(0, 10),
    endDate: new Date(date.getFullYear(), date.getMonth() + 1, 1)
      .toISOString()
      .substr(0, 10),
    ks: "",
    ksNames: [],
    generate: false,
  });

  async function getOrders() {
    const userRes = await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/orders/list`,
      { project, startDate: timePeriod.startDate, endDate: timePeriod.endDate },
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    let mappedOrders = userRes.data.map((order) => {
      return {
        ...order,
        summe:
          order.service.menge *
          order.service.anzahl *
          order.service[order.preis],
      };
    });

    const loggedInRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/userData`,
      {
        headers: {
          jwtToken: token,
        },
      }
    );
    let doneOrders = [];
    let nonUniqueKS = [];

    if (
      userData &&
      userData.permissions &&
      !userData.permissions[project].isProjectAdmin
    ) {
      console.log(userData.permissions[project].kostenstellen);

      setOrders(
        userRes.data.filter(
          (order) =>
            userData.permissions[project].kostenstellen.includes(
              order.service.kostenstelle._id
            ) && order.status === "abgenommen"
        )
      );

      doneOrders = mappedOrders.filter(
        (order) =>
          userData.permissions[project].kostenstellen.includes(
            order.service.kostenstelle._id
          ) && order.status === "abgenommen"
      );
    } else {
      setOrders(mappedOrders.filter((order) => order.status === "abgenommen"));
      doneOrders = mappedOrders.filter(
        (order) => order.status === "abgenommen"
      );
    }

    doneOrders.map((order) => {
      nonUniqueKS.push(order.service.kostenstelle._id);
    });
    let ksRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/dropdownOptions/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setKostenstellen(ksRes.data.filter((ks) => nonUniqueKS.includes(ks._id)));
  }

  let columns = [
    {
      accessorKey: "service.pos_nr",
      header: "Pos. Nr.",
    },
    {
      accessorKey: "service.pos_name",
      header: "Pos. Name",
    },
    {
      accessorKey: "service.kostenstelle.name",
      header: "Kostenstelle",
    },
    {
      accessorKey: "orderDoneDate",
      header: "Erledigt am",
    },
    {
      accessorKey: "service.anzahl",
      header: "Anzahl",
    },
    {
      accessorKey: "service.menge",
      header: "Menge",
    },
    {
      accessorKey: "_id",
      header: "Preis",
      Cell: ({ cell }) => (
        <>
          {cell.row.original.service[cell.row.original.preis].toLocaleString?.(
            "de-DE",
            {
              style: "currency",
              currency: "EUR",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}
        </>
      ),
    },
    {
      accessorKey: "summe",
      header: "Gesamtpreis",
      aggregationFn: "sum",
      AggregatedCell: ({ cell }) => (
        <div>
          Zwischensumme:{" "}
          {cell.getValue()?.toLocaleString?.("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      ),
      Cell: ({ cell }) => (
        <>
          {cell.getValue()?.toLocaleString?.("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </>
      ),
      Footer: () => (
        <>
          Gesamtsumme:{" "}
          <Box sx={{ color: "success.main", fontWeight: "bold", fontSize: 14 }}>
            {orderDataTotal.toLocaleString?.("de-DE", {
              style: "currency",
              currency: "EUR",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        </>
      ),
    },
  ];

  let table = useMaterialReactTable({
    columns,
    data: orderData,
    enableGrouping: true,
    localization: MRT_Localization_DE,
    enableSelectAll: true,
    initialState: {
      columnOrder: [],
      expanded: true,
      accessorKey: "service.kostenstelle.name",
      grouping: ["service.kostenstelle.name", "service.pos_nr"],
      pagination: { pageSize: 25, pageIndex: 0 },
    },
    enableColumnOrdering: true,
    enableGlobalFilter: true,
  });

  useEffect(() => {
    getOrders();
  }, [timePeriod, userData]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-between">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Kostenauswertung
          </h3>
        </div>
        <div className="px-4 py-5 sm:px-6 flex justify-end md:flex-1 lg:w-0">
          <div class="flex ml-3">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Von:
            </span>
            <input
              type="date"
              required="true"
              disabled={timePeriod.generate}
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  startDate: e.target.value,
                })
              }
              value={timePeriod.startDate}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            />
          </div>
          <div class="ml-3 mr-3 flex">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Bis:
            </span>
            <input
              type="date"
              disabled={timePeriod.generate}
              required="true"
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  endDate: e.target.value,
                })
              }
              value={timePeriod.endDate}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            />
          </div>
          <div class="flex mr-3">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Kostenstelle(n):
            </span>
            <select
              required="true"
              multiple
              disabled={timePeriod.generate}
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  ks: Array.from(
                    e.target.selectedOptions,
                    (option) => option.value
                  ),
                })
              }
              value={timePeriod.ks}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            >
              {kostenstellen.map((ks) => (
                <option value={ks._id}>{ks.name}</option>
              ))}
            </select>
          </div>

          {!timePeriod.generate && (
            <div class="flex">
              <button
                onClick={() => {
                  let orderData = orders.filter((order) =>
                    timePeriod.ks.includes(order.service.kostenstelle._id)
                  );
                  setOrderData(orderData);

                  let orderTotal = 0;
                  orderData.map((order) => (orderTotal += order.summe));
                  setOrderDataTotal(orderTotal);

                  setTimePeriod({
                    ...timePeriod,
                    generate: true,
                  });
                }}
                className=" whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                  />
                </svg>
              </button>
            </div>
          )}

          {timePeriod.generate && (
            <div class="flex">
              <button
                onClick={() => {
                  history.go(0);
                }}
                className=" whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6 "
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="bg-white w-full  shadow overflow-auto sm:rounded-lg flex justify-between my-5  border-gray-200 shadow  w-full sm:rounded-lg"></div>
      {timePeriod.generate && <MaterialReactTable table={table} />}
    </>
  );
}
